module.exports = __webpack_public_path__ + "11b74a345301a083090f94e4b4d94b8e.png";